import { SetPasswordForm } from "Auth/Components/SetPasswordForm";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";

export const SetPasswordPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.SetPassword.Title)}>
      <SetPasswordForm />
    </UnauthenticatedLayout>
  );
};
